import React from 'react'

const ErrorText = ({ errors, name, textColor = 'red' }) => {
  if (!errors || !errors[name]?.message) return null

  return (
    <span style={{ color: textColor, fontSize: 12, fontWeight: '400', letterSpacing: 'normal', textAlign: 'left' }}>
      {errors[name]?.message}
    </span>
  )
}

export default ErrorText
